import styled, { css } from 'styled-components';
import { generateMedia } from 'styled-media-query';
export const customMedia = generateMedia({
    phone: '767px',
    smallTablet: '768px',
    tablet: '1169px',
    desktop: '1170px'
});
const mediaMatchModifiers = {
    mobile: () => css `
    ${customMedia.lessThan('phone') ` display: none; `}
  `,
    tablet: () => css `
    ${customMedia.between('smallTablet', 'tablet') ` display: none; `}
  `,
    desktop: () => css `
    ${customMedia.greaterThan('desktop') ` display: none; `}
  `
};
export const Hidden = styled.div `
  ${({ mobile, tablet, desktop }) => css `
    ${!!mobile && mediaMatchModifiers.mobile()}
    ${!!desktop && mediaMatchModifiers.desktop()}
    ${!!tablet && mediaMatchModifiers.tablet()}
  `}
`;
//# sourceMappingURL=Hiden.js.map